import case1 from './case1'
import chartcase from './barchart'
import case2 from './case2'
import case3 from './case3'
import case4 from './case4'

export default {
  caseone: case1,
  case2,
  barchart: chartcase.barchart,
  barnegative: chartcase.barnegative,
  leida: chartcase.leida,
  case3: case3(),
  case4: case4
}



// WEBPACK FOOTER //
// ./src/mock/chartoption.js